export const ANCHOR_NAV_LABEL = 'Table of contents'
